export const RECT_WIPE_CLOSED = 'polygon(0 0,100% 0,100% 0,0 0)';
export const RECT_WIPE_BOTTOM_CLOSED = 'polygon(0 100%,100% 100%,100% 100%,0 100%)';
export const RECT_WIPE_OPEN = 'polygon(0 0,100% 0,100% 100%,0 100%)';
export const OVERLAY_WIPE_OPEN_SECONDS = 0.86;
export const OVERLAY_WIPE_REDUCED_SECONDS = 0.16;
export const OVERLAY_WIPE_CLOSE_RATE = 1.12;

// The primary navigation deliberately breathes a little longer than media overlays.
// Gallery / 3D remain snappier while the menu keeps a more cinematic pace.
export const MENU_WIPE_OPEN_SECONDS = 1.18;
export const MENU_WIPE_CLOSE_RATE = 1.08;
